namespace distill.datasets.views.createWizard2_select {
    enum DatasetCreationMethod {
        None = "None",
        Manual = "Manual",
        FormScreen = "FormScreen",
        DataSource = "DataSource",
        FileUpload = "FileUpload"
    }

    class InitArgs {
        wizardToken: string = '';
        creationMethod: DatasetCreationMethod = DatasetCreationMethod.None;
        cruxEntityId: string | null = null;
        uploadedFileToken: string | null = null;
        availableForms: { text: string; value: string }[] = [];
        availableDataSources: { text: string; value: string; disabled?: boolean }[] = [];
        urls!: {
            navigateToStep: string;
        };
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        $(function () {
            bindEvents();
            updateToolbar();
        });
    }

    function getParentButton(selector: string): JQuery<HTMLElement> {
        return $(parent.document).find(selector) as unknown as JQuery<HTMLElement>;
    }

    function bindEvents(): void {
        getParentButton('#wizardBackBtn').on('click', function (e) {
            e.preventDefault();
            window.location.href = _initArgs.urls.navigateToStep + '?step=1&token=' + _initArgs.wizardToken;
        });

        getParentButton('#wizardNextBtn').on('click', function () {
            if (validateForm())
                submitForm();
        });

        $('#formPicker').on('change', function () {
            const entityId = $(this).val()?.toString() || '';
            if (entityId) {
                $('#CruxEntityId').val(entityId);
                submitForm();
            }
        });

        $('#dataSourcePicker').on('change', function () {
            const entityId = $(this).val()?.toString() || '';
            if (entityId) {
                $('#CruxEntityId').val(entityId);
                submitForm();
            }
        });

        const $dropZone = $('#fileDropZone');
        const $fileInput = $('#fileUploadInput');

        if ($dropZone.length) {
            $dropZone.on('dragover', function (e) {
                e.preventDefault();
                $(this).addClass('bg-light');
            });

            $dropZone.on('dragleave drop', function (e) {
                e.preventDefault();
                $(this).removeClass('bg-light');
            });

            $dropZone.on('drop', function (e) {
                e.preventDefault();
                const files = (e.originalEvent as DragEvent)?.dataTransfer?.files;
                if (files && files.length > 0)
                    handleFileSelected(files[0]);
            });

            $fileInput.on('change', function () {
                const files = (this as HTMLInputElement).files;
                if (files && files.length > 0)
                    handleFileSelected(files[0]);
            });
        }
    }

    function updateToolbar(): void {
        const $next = getParentButton('#wizardNextBtn');
        const method = _initArgs.creationMethod;

        if (method === DatasetCreationMethod.FileUpload && _initArgs.uploadedFileToken)
            $next.removeClass('d-none');
        else
            $next.addClass('d-none');
    }

    function validateForm(): boolean {
        const method = _initArgs.creationMethod;
        if (method === DatasetCreationMethod.FileUpload && !_initArgs.uploadedFileToken) {
            appn.toast.notify(appn.toast.Type.error, T('Please upload a file.'));
            return false;
        }
        if ((method === DatasetCreationMethod.FormScreen || method === DatasetCreationMethod.DataSource) && !$('#CruxEntityId').val()) {
            appn.toast.notify(appn.toast.Type.error, T('Please select an entity.'));
            return false;
        }
        return true;
    }

    function handleFileSelected(file: File): void {
        const dotIndex = file.name.lastIndexOf('.');
        if (dotIndex === -1) {
            appn.toast.notify(appn.toast.Type.error, T('Only CSV and XLSX files are supported.'));
            return;
        }
        
        const ext = file.name.substring(dotIndex + 1).toLowerCase();
        if (ext !== 'csv' && ext !== 'xlsx') {
            appn.toast.notify(appn.toast.Type.error, T('Only CSV and XLSX files are supported.'));
            return;
        }

        if (file.size > 50 * 1024 * 1024) {
            appn.toast.notify(appn.toast.Type.error, T('File too large. Maximum size is 50MB.'));
            return;
        }

        submitForm();
    }

    function submitForm(): void {
        ($('form')[0] as HTMLFormElement).submit();
    }
}
